// Записи на устройстве: отдельный кэш audio-v1 в Cache Storage. Он не версионируется вместе
// с оболочкой — файл по ключу неизменяем. Какие ключи нужны, решает audioKeysToCache (logic.ts);
// здесь — докачка недостающих и удаление ненужных. Service worker отдаёт записи из этого кэша.

import { audioUrl } from './audio.ts';

export const AUDIO_CACHE = 'audio-v1';
const PREFIX = '/api/audio/';

function hasCaches(): boolean {
  return typeof caches !== 'undefined';
}

function keyOf(req: Request): string {
  const p = new URL(req.url).pathname;
  return p.startsWith(PREFIX) ? decodeURIComponent(p.slice(PREFIX.length)) : '';
}

/** Ключи записей, сохранённых на устройстве. */
export async function cachedAudioKeys(): Promise<Set<string>> {
  if (!hasCaches()) return new Set();
  const c = await caches.open(AUDIO_CACHE);
  return new Set((await c.keys()).map(keyOf).filter(Boolean));
}

/**
 * Приводит кэш к нужному набору: удаляет лишнее, докачивает недостающее.
 * Сбой сети прерывает докачку — остальное догрузится при следующей синхронизации.
 * Возвращает ключи, которые есть на устройстве после синхронизации.
 */
export async function syncAudioCache(need: Set<string>): Promise<Set<string>> {
  if (!hasCaches()) return new Set();
  const c = await caches.open(AUDIO_CACHE);
  const have = new Set<string>();
  for (const req of await c.keys()) {
    const k = keyOf(req);
    if (k && need.has(k)) have.add(k);
    else await c.delete(req);
  }
  for (const k of need) {
    if (have.has(k)) continue;
    try {
      const resp = await fetch(audioUrl(k), { credentials: 'same-origin' });
      if (resp.status === 200) {
        await c.put(audioUrl(k), resp);
        have.add(k);
      }
    } catch {
      break; // нет сети
    }
  }
  return have;
}

export async function clearAudioCache(): Promise<void> {
  if (hasCaches()) await caches.delete(AUDIO_CACHE);
}
